import {
  Android,
  AssignmentReturn,
  BeachAccess,
  Bolt,
  Book,
  CardGiftcard,
  Casino,
  Category,
  Checkroom,
  ChildFriendly,
  Computer,
  ContentCut,
  DirectionsBus,
  DirectionsCar,
  Engineering,
  FamilyRestroom,
  FitnessCenter,
  Flight,
  Gavel,
  HealthAndSafety,
  HelpOutlined,
  Hive,
  Home,
  HomeWork,
  LaptopChromebook,
  LocalAtm,
  LocalGasStation,
  LocalLaundryService,
  LocalParking,
  LocalPharmacy,
  LocalPostOffice,
  MedicalServices,
  Palette,
  Payments,
  People,
  Percent,
  // Legacy icons kept for backward compatibility:
  Power,
  RequestQuote,
  Restaurant,
  Router,
  Savings,
  School,
  Shield,
  ShoppingCart,
  Smartphone,
  SolarPower,
  SwapHoriz,
  Toll,
  TrendingUp,
  Tv,
  TwoWheeler,
  WaterDrop,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import React from 'react';

export const CATEGORY_ICON_MAP: Record<
  string,
  React.ComponentType<SvgIconProps>
> = {
  // New generic names:
  hive: Hive,
  car: DirectionsCar,
  scissors: ContentCut,
  home: Home,
  shapes: Category,
  gas: LocalGasStation,
  mail: LocalPostOffice,
  gym: FitnessCenter,
  people: People,
  lightning: Bolt,
  school: School,
  parking: LocalParking,
  casino: Casino,
  beach: BeachAccess,
  laptop: LaptopChromebook,
  baby: ChildFriendly,
  android: Android,
  gavel: Gavel,
  computer: Computer,
  chart: TrendingUp,
  percent: Percent,
  laundry: LocalLaundryService,
  atm: LocalAtm,
  book: Book,
  shopping: ShoppingCart,
  two_wheeler: TwoWheeler,
  engineer: Engineering,
  cash: Payments,
  savings: Savings,
  gift: CardGiftcard,
  solar: SolarPower,
  palette: Palette,
  return: AssignmentReturn,
  building: HomeWork,
  restaurant: Restaurant,
  pharmacy: LocalPharmacy,
  shield: Shield,
  heart_shield: HealthAndSafety,
  router: Router,
  phone: Smartphone,
  arrows: SwapHoriz,
  bus: DirectionsBus,
  hanger: Checkroom,
  tolls: Toll,
  flight: Flight,
  drop: WaterDrop,
  payslip: RequestQuote,
  family: FamilyRestroom,
  other: HelpOutlined,

  // Legacy fallback mappings for compatibility with old category icons:
  food: Restaurant,
  transport: DirectionsCar,
  utilities: Power,
  entertainment: Tv,
  health: MedicalServices,
  education: School,
  housing: Home,
  travel: Flight,
};

export const CATEGORY_ICONS = [
  'hive',
  'car',
  'scissors',
  'home',
  'shapes',
  'gas',
  'mail',
  'gym',
  'people',
  'lightning',
  'school',
  'parking',
  'casino',
  'beach',
  'laptop',
  'baby',
  'android',
  'gavel',
  'computer',
  'chart',
  'percent',
  'laundry',
  'atm',
  'book',
  'shopping',
  'two_wheeler',
  'engineer',
  'cash',
  'savings',
  'gift',
  'solar',
  'palette',
  'return',
  'building',
  'restaurant',
  'pharmacy',
  'shield',
  'heart_shield',
  'router',
  'phone',
  'arrows',
  'bus',
  'hanger',
  'tolls',
  'flight',
  'drop',
  'payslip',
  'family',
  'other',
].map((key) => ({
  id: key,
  translationKey: `CATEGORY_ICON_${key.toUpperCase()}`,
}));
